import React from 'react';
import { Visa, Mastercard, Klarna } from 'react-pay-icons';

const PaymentIcons = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Visa style={{ height: '32px', width: 'auto' }} />
      <Mastercard style={{ height: '32px', width: 'auto' }} />
      <Klarna style={{ height: '32px', width: 'auto' }} />
    </div>
  );
};

export default PaymentIcons;

